// extracted by mini-css-extract-plugin
export default {"card":"FeatureCard_card__w0Xqd","avatar":"FeatureCard_avatar__q61ku","button":"FeatureCard_button__DhZN4"};